import { isWebView } from 'shared/constants/AppTypeConstants';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import { SuperPayBankAccountDTO } from 'shared/modules/superpay/SuperPayDTO';
import { BankDifferentBanner } from '../../BankDifferentBanner';
import { useACHPaymentInfo } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';

const ACH_CHANGE_BANK_DETAILS_WEB_ROUTE =
  '/profile/ach_payment/change-bank-details';
const ACH_CHANGE_BANK_DETAILS_WEBVIEW_ROUTE =
  '/profile/ach-payment/change-bank-details';

interface SuperPayACHBankDifferentBannerProps {
  bankAccount?: SuperPayBankAccountDTO;
}

export function SuperPayACHBankDifferentBanner({
  bankAccount,
}: SuperPayACHBankDifferentBannerProps) {
  const shouldShowBanner = !!bankAccount?.is_ach_bank_different;

  const { data: paymentInfo } = useACHPaymentInfo({
    enabled: shouldShowBanner,
  });

  if (!shouldShowBanner || !bankAccount) {
    return null;
  }

  const hoursUntilUpdateAllowed = paymentInfo?.hours_until_update_allowed;
  const isDisabled = !!hoursUntilUpdateAllowed && hoursUntilUpdateAllowed > 0;

  return (
    <BankDifferentBanner
      title="Your ACH bank account is different from SuperPay"
      description="It seems you have different bank accounts in ACH Payment Info section and SuperPay. If you want to receive ACH payment to the same bank account, change ACH Payment Info section too"
      buttonLabel="Change ACH Bank Account"
      to={
        isWebView
          ? ACH_CHANGE_BANK_DETAILS_WEBVIEW_ROUTE
          : ACH_CHANGE_BANK_DETAILS_WEB_ROUTE
      }
      dismissStorageKey="superpay_ach_bank_different_banner_dismissed"
      dismissTag={bankAccount.display_number ?? ''}
      disabled={isDisabled}
      disabledTooltip={
        isDisabled
          ? `You have changed your email/phone in the last 24 hours. You can't change ACH bank details for ${hoursUntilUpdateAllowed} ${formatPlural(hoursUntilUpdateAllowed, 'hour', 'hours')}.`
          : undefined
      }
    />
  );
}
